
export const buildChips = ({ values, selectedDate, rolesData, productData, phaseData }) => {
  const chips = [];

  const lookups = [
    { key: "role",     data: rolesData,   prefix: "Role" },
    { key: "product",  data: productData, prefix: "Product" },
    { key: "phase_id", data: phaseData,   prefix: "Phase" },
  ];

  lookups.forEach(({ key, data, prefix }) => {
    const found = data?.find((item) => item.id === values[key]);
    if (found) chips.push({ key, label: prefix, value: found.name });
  });

 if (selectedDate?.from || selectedDate?.to) {
  chips.push({
    key: "date",
    label: "Date",
    value: `${selectedDate.from || ""} - ${selectedDate.to || ""}`,
  });
}

  return chips;
};